// wysiwyg editor
import commonClass from "./commonClass";

export default class wysiwygClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$tgt = $('.js-wysiwyg');
    this._$area = $('.c-wysiwyg');
  }

  // 初期化用関数
  _init() {
    this._main();
    this._preview();
  }

  _main() {
    var cls = this;
    var elem = cls._$tgt;

    var textarea = cls.textarea = elem;

    // 太字
    $(document).on('click', '.js-wysiwyg-btn', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var $textarea = $target.find('.js-wysiwyg');

      if($(this).hasClass('bold')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '<strong>', '</strong>');
      }
      if($(this).hasClass('italic')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '<em>', '</em>');
      }

      if($(this).hasClass('underline')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '<u>', '</u>');
      }

      if($(this).hasClass('strikethrough')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '<del>', '</del>');
      }
      if($(this).hasClass('font')) {
        setStyle($(this), 'font');
      }

      if($(this).hasClass('link')) {
        setStyle($(this), 'link');
      }

      if($(this).hasClass('frame_red')) {
        setStyle($(this), 'frame');
      }

      if($(this).hasClass('quote_bg')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '\n<blockquote class="ar-quote__ground text_m">\n', '\n</blockquote>\n');
      }

      if($(this).hasClass('quote_line')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '\n<blockquote class="ar-quote__border text_m">\n', '\n</blockquote>\n');
      }

      if($(this).hasClass('column')) {
        setStyle($(this), "");
        cls._addTag($textarea[0], '\n<div class="columnA">\n <div class="columnB">\n', '\n </div>\n</div>\n');
      }

      if($(this).hasClass('br')) {
        setStyle($(this), "");
        cls._addHtml($textarea[0], '<br />\n');
      }

      if($(this).hasClass('br_clear')) {
        setStyle($(this), "");
        cls._addHtml($textarea[0], '<br clear="all" />\n');
      }

      if($(this).hasClass('table')) {
        setStyle($(this), 'table');
      }

      if($(this).hasClass('image')) {
        setStyle($(this), "");
        $('.js-select').on('click', function(){
          var me = this;
          $('.js-select').parent().removeClass('is-active');
          $(me).parent().addClass('is-active');
        });
        var snp_flag1 = false;

        $(document).off('click', '.js-set-snp-img');
        $(document).on('click', '.js-set-snp-img', function(){
          var $parent = $(this).parents('.c-modal');
          var $select_image = $parent.find('.is-active');
          var snp = {};
              snp.size = $parent.find('.snp_size').val();
              snp.link = $parent.find('.snp_link').prop('checked');
              snp.resize = $parent.find('.snp_resize').prop('checked');
              snp.cls = $parent.find('.snp_cls').val();
              snp.picid = $select_image.find('.snp_id').text();
              snp.fname = $select_image.find('.snp_fname').text();

          //画像が選ばれていなかった場合
          if (snp.picid == null || snp.picid == "" ) {
            alert('画像を選択してください')
            return false;
          }

          function checkjpg(filename) {
            filename.match(/\.\w+$/);
            var ext = RegExp.lastMatch;
            if (ext.toLowerCase() == ".gif") {
              return 1;
            }
            else {
              return 0;
            }
          }

          var html = '[[image id=' + snp.picid;
          if (checkjpg(snp.fname) == 0) {
            if (snp.size != '') {
              html += ' Size=' + snp.size;
            }
            if (snp.link == true) {
              html += ' Zoom=true';
            }
            else {
              html += ' Zoom=false';
            }
          }
          else {
            html += ' Zoom=false';
          }
          if (snp.cls != '') {
            html += ' Class=' + snp.cls;
          }
          //html += ' Resize=' + snp.resize;
          if (snp.resize != undefined && snp.resize != '') {
            html += ' Resize=' + snp.resize;
          }

          html += ' ]]\n';

          $(this).parents('.c-modal').hide();
          var $body = $('body');
          $body.removeClass('isShowhowModal');
          if(!snp_flag1) {
            cls._addHtml($textarea[0], html);
            snp_flag1 = true;
          }
        });
      }

      if($(this).hasClass('snippet')) {
        setStyle($(this), 'snippet');
        var snp_flag2 = false;
        // snippet article
        $(document).off('click', '.js-set-snippet');
        $(document).on('click','.js-set-snippet', function() {
          var $parent = $(this).parents('.c-modal');
          var type = $parent.data('mdtrg').split('-')[1];
          var snp = {};
              snp.id = $parent.find('.snp_id:not(:disabled)').length > 1 ? $parent.find('.snp_id:not(:disabled):checked').val() : $parent.find('.snp_id:not(:disabled)').val();
              snp.tag = $parent.find('.snp_tag').val();
              snp.tpl = $parent.find('.snp_tpl').val();
              snp.cnt = $parent.find('.snp_cnt').val();
              snp.more = $parent.find('.snp_more').val();
              snp.isPrv = $parent.find('.snp_prv').prop('checked');
              snp.isAdv = $parent.find('.snp_adv').prop('checked');

          var html = '[[' + type;
          if (snp.id != '') {
            html += ' id=' + snp.id;
          } else if (snp.tag != '') {
            html += ' tag=' + snp.tag;
          }

          if (snp.tpl != '' && snp.tpl != undefined) {
            html += ' tmpl=' + snp.tpl;
          }
          if (snp.cnt != '' && snp.cnt != undefined) {
            html += ' count=' + snp.cnt;
            if (snp.more != '' && snp.more != undefined) {
              html += ' more=' + snp.more;
            }
          }

          if(type !== 'event') {
            if (snp.isPrv) {
              html += ' preview=' + snp.isPrv;
            }
          }

          if (type === 'cont') {
            if (!snp.isAdv) {
              html += ' dependonlead=true';
            }
            else {
              html += ' dependonlead=false';
            }
          }
          html += ' ]]\n';

          $(this).parents('.c-modal').hide();
          if(!snp_flag2) {
            cls._addHtml($textarea[0], html);
            snp_flag2 = true;
          }
          $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
          
          var $window = $(window);
          var $body = $('body');
          $target.parents('.c-modal').fadeOut();
          $body.removeClass('isShowhowModal');
        });

        $(document).off('change', '.js-snp-select-enquete-type');
        $(document).on('change', '.js-snp-select-enquete-type', function () {
          var me = $(this);
          var box = me.closest('.c-modal_form');
          if (me.val() === '0') {
            // 設定したアンケート
            box.find('.snp-select-enquete').prop('disabled', false);
            box.find('.snp-input-enquete').prop('disabled', true);
          } else {
            // アンケートIDを設定
            box.find('.snp-select-enquete').prop('disabled', true);
            box.find('.snp-input-enquete').prop('disabled', false);
          }
        });
      }

      function setStyle(cls, set) {
        $target.find('.js-wysiwyg-btn').removeClass('is-select');
        cls.addClass('is-select');
        $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
        if(set !== "") {
          $target.find('.c-wysiwyg_setting-' + set).addClass('is-show');
        }
      }
    });

    // フォント設定
    $(document).on('click', '.js-set-font', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var $textarea = $target.find('.js-wysiwyg');
      var font_cls = $target.find('.font_size').val();
      if ($target.find('.font_weight').prop('checked')) font_cls += 'b';
      cls._addTag($textarea[0], '<span class="' + font_cls + '">', '</span>');
      $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
    });

    // URL入力
    $(document).on('click', '.js-slct-url', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var url = $(this).data('val');
      $target.find('.set_url').val(url);
      //$target.find('.c-wysiwyg_setting').children().removeClass('is-show');
    });

    // URL設定
    $(document).on('click', '.js-set-url', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var $textarea = $target.find('.js-wysiwyg');
      var url = $target.find('.set_url').val();
      var blank = $target.find('.target_blank').prop('checked')? ' target="_blank"': '';
      cls._addTag($textarea[0], '<a href="' + url + '"' + blank + '>', '</a>');
      $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
    });

    // フレーム設定
    $(document).on('click', '.js-set-frame', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var $textarea = $target.find('.js-wysiwyg');
      var preset = $target.find('.frame_preset').val();
      var color = $target.find('.frame_color').val();
      cls._addTag($textarea[0], '<div class="' + preset + '" id="' + color + '">', '</div>');
      $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
    });

    // テーブル設定
    $(document).on('click', '.js-set-table', function() {
      var $target= $(this).parents('.c-wysiwyg');
      var $textarea = $target.find('.js-wysiwyg');
      var tbl = {};
          tbl.cls = $target.find('.table_class').val();
          tbl.ttl = $target.find('.table_title').val();
          tbl.col = $target.find('.table_col').val();
          tbl.row = $target.find('.table_row').val();

      var classAtr = '';
      if (tbl.cls != '') {
          classAtr = ' class="' + tbl.cls + '"';
      }
      var html = '\n<table' + classAtr + '>\n';
      if (tbl.ttl  != '') {
          html += '<tr><td colspan="' + tbl.col + '">' + tbl.ttl  + '</td></tr>\n'
      }
      for (var i = 0; i < tbl.row; i++) {
          html += '<tr>';
          for (var m = 0; m < tbl.col; m++) {
              classAtr = ' class="td2"'
              if (m == 0 && $target.find('.table_col_header').prop('checked')) classAtr = ' class="td3"'
              if (i == 0 && $target.find('.table_row_header').prop('checked')) classAtr = ' class="td1"'
              if (tbl.cls == '') {
                  classAtr = '';
              }
              html += '<td' + classAtr + '></td>';
          }
          html += '</tr>\n';
      }
      html += '</table>\n';
      cls._addHtml($textarea[0], html);
      $target.find('.c-wysiwyg_setting').children().removeClass('is-show');
    });

    $(document).on('click', '.js-hide', function() {
      $(this).parents('.c-wysiwyg_setting').children().removeClass('is-show');
    });

  }
  // エディタ表示部分
  /*
  _createEditor(elem, width) {
    var cls = this;

    var textarea = cls.textarea = elem;
    if (width == 0) width = '100%';
    var container = cls.container = $("<div/>").addClass('c-wysiwyg').width(width).insertAfter(textarea);
    var toolbar = cls.toolbar = $("<div/>").addClass("c-wysiwyg_toolbar").appendTo(container);
    var setting = cls.setting = $("<div/>").addClass("c-wysiwyg_setting").appendTo(container);

    cls._toolbar(elem);

    container.append(textarea);
    cls._preview(elem, container, width);
  }
  */
  // エディタ表示部分 ツールバー
  /*
  _toolbar(elem) {
    var cls = this;

    var menuItem = function(className, altText, action) {
        return $("<li/>").append($("<a href='javascript:void(0);'/>").addClass(className).attr("title", altText).click(function() { action.call(); }));
    };

    // ツールバー 表示ボタンの設定
    addButtons();

    function addButtons() {
      var ul = $("<ul/>").appendTo(cls.toolbar);
      ul.append(menuItem('bold', '太字', (function() { cls._addTag(elem[0], '<strong>', '</strong>'); })));
      ul.append(menuItem('italic', '斜体', (function() { cls._addTag(elem[0], '<em>', '</em>'); })));
      ul.append(menuItem('underline', '下線', (function() { cls._addTag(elem[0], '<u>', '</u>'); })));
      ul.append(menuItem('strikethrough', '打ち消し線', (function() { cls._addTag(elem[0], '<del>', '</del>'); })));
      ul.append(menuItem('font', 'フォント設定', (function() { cls._showSetting(); })));
      ul.append(menuItem('link', 'リンク', (function() { openWindow('/js/myeditor/html/myeditor_link.htm', 460, 200); })));
      ul.append(menuItem('frame_red', '見出し枠', (function() { openWindow('/js/myeditor/html/myeditor_box.htm', 240, 160); })));
      // ↓これは元々コメントアウトでした
      //ul.append(menuItem('frame_red', '見出し枠（赤）', (function() { cls._addTag(elem[0], '\n<div class="box" id="red">\n', '\n</div>\n'); })));
      //ul.append(menuItem('frame_orange', '見出し枠（オレンジ）', (function() { cls._addTag(elem[0], '\n<div class="box" id="orange">\n', '\n</div>\n'); })));
      //ul.append(menuItem('frame_blue', '見出し枠（青）', (function() { cls._addTag(elem[0], '\n<div class="box" id="blue">\n', '\n</div>\n'); })));
      //ul.append(menuItem('frame_green', '見出し枠（緑）', (function() { cls._addTag(elem[0], '\n<div class="box" id="green">\n', '\n</div>\n'); })));
      ul.append(menuItem('quote_bg', '引用文（下地）', (function() { cls._addTag(elem[0], '\n<blockquote class="ar-quote__ground text_m">\n', '\n</blockquote>\n'); })));
      ul.append(menuItem('quote_line', '引用文（罫線）', (function() { cls._addTag(elem[0], '\n<blockquote class="ar-quote__border text_m">\n', '\n</blockquote>\n'); })));
      ul.append(menuItem('column', 'コラム枠', (function() { cls._addTag(elem[0], '\n<div class="columnA">\n <div class="columnB">\n', '\n </div>\n</div>\n'); })));
      ul.append(menuItem('br', 'BR改行', (function() { cls._addHtml(elem[0], '<br />\n'); })));
      ul.append(menuItem('br_clear', 'BR改行（クリア）', (function() { cls._addHtml(elem[0], '<br clear="all" />\n'); })));
      ul.append(menuItem('table', 'テーブル', (function() { openWindow('/js/myeditor/html/myeditor_table.htm', 420, 220); })));
      ul.append(menuItem('image', '画像スニペット', (function () { openWindow('/menu/article/SnippetPictureList.aspx', 650, 610); })));
      // ↓これは元々コメントアウトでした
      //ul.append(menuItem('social', 'ソーシャルパーツスニペット', (function () { openWindow('/js/myeditor/html/snippet_social.htm', 550, 150); })));
      ul.append(menuItem('snippet', 'スニペット', (function() { openWindow('/js/myeditor/html/snippet_article.htm', 450, 250); })));
    };
  }
  */

  _showSetting() {

  }

  // エディタ表示部分 プレビュー画面
  _preview() {
    // 表示タブ
    $(document).on('click', '.c-wysiwyg_tab-preview-show', function() {
      var $target = $(this).parents('.c-wysiwyg');
      if ($target.length === 0) {
        $target = $(this).closest('.c-wysiwyg_wrp');
      }
      $(this).prev().removeClass("is-selected");
      $(this).addClass("is-selected");
      appendPreviewArea($target);
      $(this).parent().next().addClass('is-show');
    });

    // 非表示タブ
    $(document).on('click', '.c-wysiwyg_tab-preview-hide', function() {
      $(this).next().removeClass("is-selected");
      $(this).addClass("is-selected");
      $(this).parent().next().removeClass('is-show');
    });

    // テキストのコピーと描画
    function appendPreviewArea($target) {
      var html = $target.find('textarea').val();
      var $preview = $target.find(".c-wysiwyg_preview");
      //$preview.empty().html(html);
      // iframe用
      var body =  $preview.contents().find("html");
      body.html(html);
    }
  }

  // ボタン要素 タグ追加 開始・終了タグ
  _addTag(obj, startTag, endTag) {
    //IE
    if (document.selection) {
      obj.focus();
      var str = document.selection.createRange().text;
      if (!str) {
          document.selection.createRange().text = startTag + endTag;
          return;
      }
      document.selection.createRange().text = startTag + str + endTag;
      return;
    }
    //Mozilla
    else if ((obj.selectionEnd) > 0) {
      var startPos = obj.selectionStart;
      var endPos = obj.selectionEnd;
      var top = obj.scrollTop;

      obj.value = obj.value.substring(0, startPos)
                    + startTag
                    + obj.value.substring(startPos, endPos)
                    + endTag
                    + obj.value.substring(endPos, obj.value.length);
      obj.focus();
      obj.selectionStart = endPos + startTag.length + endTag.length;
      obj.selectionEnd = endPos + startTag.length + endTag.length;
      obj.scrollTop = top;
    }
    //Other
    else {
        obj.value += startTag + endTag;
    }
  }

  // ボタン要素 タグ追加
  _addHtml(obj, html) {

    //IE
    if (document.selection) {
      obj.focus();
      var str = document.selection.createRange().text;
      document.selection.createRange().text = html;
      return;
    }
    //IE以外
    else if ((obj.selectionEnd) > 0) {
      var startPos = obj.selectionStart;
      var endPos = obj.selectionEnd;
      var top = obj.scrollTop;

      obj.value = obj.value.substring(0, startPos)
                    + html
                    + obj.value.substring(endPos, obj.value.length);
      obj.focus();
      obj.selectionStart = endPos + html.length;
      obj.selectionEnd = endPos + html.length;
      obj.scrollTop = top;
      //return;
    }
    else {
      obj.value += html;
    }
  }
  /*_addOpenerTag(id, startTag, endTag) {

    var obj = window.opener.$('#' + id)[0];

    //IE
    if (window.opener.document.selection) {
        obj.focus();
        var str = window.opener.document.selection.createRange().text;
        if (!str) {
            return;
        }
        window.opener.document.selection.createRange().text = startTag + str + endTag;
        return;
    }
    //Mozilla
    else if (obj.selectionEnd > 0) {
        var startPos = obj.selectionStart;
        var endPos = obj.selectionEnd;
        var top = obj.scrollTop;

        obj.value = obj.value.substring(0, startPos)
                      + startTag
                      + obj.value.substring(startPos, endPos)
                      + endTag
                      + obj.value.substring(endPos, obj.value.length);
        obj.focus();
        obj.selectionStart = endPos + startTag.length + endTag.length;
        obj.selectionEnd = endPos + startTag.length + endTag.length;
        obj.scrollTop = top;
    }
    //Other
    else {
        obj.value += startTag + endTag;
    }
  }*/
  /*_addOpenerHtml(id, html) {

    var obj = window.opener.$('#' + id)[0];

    //IE
    if (window.opener.document.selection) {
        obj.focus();
        window.opener.document.selection.createRange().text = html;
        return;
    }
    //IE以外
    else if ((obj.selectionEnd) > 0) {
        var startPos = obj.selectionStart;
        var endPos = obj.selectionEnd;
        var top = obj.scrollTop;

        obj.value = obj.value.substring(0, startPos)
                      + html
                      + obj.value.substring(endPos, obj.value.length);
        obj.focus();
        obj.selectionStart = endPos + html.length;
        obj.selectionEnd = endPos + html.length;
        obj.scrollTop = top;
    }
    else {
        obj.value += html;
    }
  }*/
  /*_getRequest(name) {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars[name];
  }*/
  /*_resize(img) {
    var w = $(img).width();
    var h = $(img).height();
    if (w >= h) {
        if (w > 100) {
            $(img).width(100);
            $(img).height(h * 100 / w);
        }
    } else {
        if (h > 100) {
            $(img).height(100);
            $(img).width(w * 100 / h);
        }
    }
  }*/
  /*_addImage(id, src) {
    var cls = this;
      cls._addHtml($("#" + id)[0], "<image src='" + src + "' />\n");
  }*/
  /*_rollingText(text) {
    var ret = "";
    for (var i = 0; i < text.length; i = i + 17) {
        ret += text.substring(i, Math.min(i + 17, text.length)) + "<wbr />";
    }
    return ret;
  }*/
}